module.exports = __webpack_public_path__ + "img/checkdage-gift.623f7605.png";